export default __webpack_public_path__ + "static/media/extingaImg_3.d093a15e.png";